<template>
  <div id="beat-progress">
    <beat-loader :loading="loading" :width="width" :color="color"></beat-loader>
  </div>
</template>

<script>
import { BeatLoader } from '@saeris/vue-spinners';

export default {
  name: 'beat-progress',
  components: { BeatLoader },
  props: {
    width: {
      type: Number,
      default: 100
    },
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#99cc22'
    }
  }
};
</script>

<style scoped>
</style>
